const Request = {
    appendUtmReferrer: (data) => window && window.Artcloud
        ? {
            ...data,
            Referrer: window.Artcloud.cookie.get(window.Artcloud.auth.keys.cookies.referrer),
            Utm: window.Artcloud.cookie.get(window.Artcloud.auth.keys.cookies.utm)
        }
        : { ...data },

    header: {
        apiKey: () => window && window.Artcloud
            ? { key: window.Artcloud.auth.keys.request.api, value: window.Artcloud.auth.values.request.onboarding }
            : null,

        build: () => {
            const headers = { 'Content-Type': 'application/json' };
            [Request.header.apiKey(), Request.header.journey(), Request.header.session()]
                .filter((header) => header !== null)
                .forEach((header) => { headers[header.key] = header.value; });
            return headers;
        },

        journey: () => {
            if (!window || !window.Artcloud) {
                return null;
            }
            const cookieKey = window.Artcloud.auth.keys.cookies.onboardingId;
            const existing = window.Artcloud.cookie.get(cookieKey);
            if (existing) {
                return { key: window.Artcloud.auth.keys.request.onboardingId, value: existing };
            }
            if (typeof crypto === 'undefined' || typeof crypto.randomUUID !== 'function') {
                return null;
            }
            const created = crypto.randomUUID();
            window.Artcloud.cookie.set(cookieKey, created);
            return { key: window.Artcloud.auth.keys.request.onboardingId, value: created };
        },

        session: () => {
            const session = window && window.Artcloud
                ? window.Artcloud.cookie.get(window.Artcloud.auth.keys.cookies.session)
                : null;
            return session ? { key: 'Authorization', value: 'Bearer ' + session } : null;
        }
    },

    post: (url, body) => Request.send('POST', url, Request.appendUtmReferrer(body), Request.header.build()),

    put: (url, body) => Request.send('PUT', url, { ...body }, Request.header.build()),

    send: async (method, url, body, headers) => {
        const response = await fetch(url, {
            method,
            headers,
            body: body === undefined ? undefined : JSON.stringify(body),
        });
        let parsedBody = null;
        try { parsedBody = await response.json(); } catch (_) { /* no body */ }
        return { status: response.status, body: parsedBody };
    },
}
export default Request;
